<template>
  <ConfirmAccountForm
    v-model="confirmAccountModel"
    @confirmAccount="confirm"
    @createAnAccountButton="createAnAccountButton"
  />
</template>

<script>
import ConfirmAccountForm from "@/components/ConfirmAccountForm.vue";
import { error } from "@/services/LoggerService";
import { login } from "@/mixins/shared";
import { AuthActionTypes } from "@/store/auth/actions";
import Vue from "vue";
import { useStore } from "@/store";
import { ApiService } from "@/services/ApiService";

export default Vue.extend({
  name: "ConfirmAccount",
  components: {
    ConfirmAccountForm,
  },
  data() {
    return {
      confirmAccountModel: {
        email: "",
        code: '',
      }
    };
  },
  methods: {
    async confirm({email, password}) {
      try {
        const newPasswordResult = await this.completeNewPassword(password);
        if (!newPasswordResult) {
          return;
        }
        const loginResult = await login(email, password);
        if (loginResult) {
            await this.confirmAccount();
           const groups = useStore().getters.getGroups;
            if (groups.includes("Admin") || groups.includes("Worker"))
              this.$router.push({ name: "Admin" });
            else this.$router.push({ name: "MyBarrels" });
        }
      } catch (e) {
        alert(e);
        error(e);
      }
    },
    async confirmAccount(){
      try{
        await ApiService.Instance.confirmAccount();
      }catch(e){
        error(e);
      }
    },
    async completeNewPassword(newPassword){
      return this.$store.dispatch(AuthActionTypes.CompleteNewPassword, newPassword);
    },
    createAnAccountButton(){
      this.$router.push({name: "Signup"});
    }
  },
  async beforeMount(){
    this.confirmAccountModel.email = this.$route.params.email;
    this.confirmAccountModel.code = this.$route.params.code;

    if (this.confirmAccountModel.code) {
        await this.$store.dispatch(AuthActionTypes.Login, {
          email: this.confirmAccountModel.email,
          password: this.confirmAccountModel.code,
        });
      }
  }
});
</script>

<style scoped></style>
